import { axiosInstance } from '@services/base-service';

const transactionsUri = '/merchant/bff/transactions';

export const getTransactions = ({ merchantId, query }) =>
  axiosInstance.getInstance().get(`${transactionsUri}/transactions/${merchantId}?${query}`);

export const doRefund = ({ merchantUuid, authorizationId, body }) =>
  axiosInstance.getInstance().post(`${transactionsUri}/refund/${merchantUuid}/${authorizationId}`, {
    payload: body,
  });

export const getMovements = ({ merchantId, query }) =>
  axiosInstance.getInstance().get(`${transactionsUri}/transactions/account/${merchantId}?${query}`);

export const getRefundDetail = (refundId) =>
  axiosInstance.getInstance().get(`${transactionsUri}/refund/find/${refundId}`);

export const getTransactionsDetails = (payload) =>
  axiosInstance.getInstance().post(`${transactionsUri}/transaction-detail`, {
    payload,
  });
